import React, { useEffect, useState } from "react";
import config from "../../config";
import apiClient from "../../services/apiClient";

interface Organization {
  id: number;
  org_display_name: string;
  org_search_name: string;
  org_created: string;
  local_name_for_team_admin: string;
  local_name_for_primary_division: string;
  local_name_for_secondary_division: string;
}

const OrganizationList: React.FC = () => {
  const [organizations, setOrganizations] = useState<Organization[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const baseUrl = config.API_BASE_URL;
  const endpoint = "organizations/all";

  useEffect(() => {
    apiClient
      .get<Organization[]>(`${baseUrl}${endpoint}`)
      .then((response) => {
        setOrganizations(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Failed to fetch organizations");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <table>
      <thead>
        <tr>
          <th>Org Display Name</th>
          <th>Org Created</th>
          <th>Local Name for Team Admin</th>
          <th>Local Name for Primary Division</th>
          <th>Local Name for Secondary Division</th>
        </tr>
      </thead>
      <tbody>
        {organizations.map((org) => (
          <tr key={org.id}>
            <td>{org.org_display_name}</td>
            <td>{new Date(org.org_created).toLocaleDateString()}</td>
            <td>{org.local_name_for_team_admin}</td>
            <td>{org.local_name_for_primary_division}</td>
            <td>{org.local_name_for_secondary_division}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OrganizationList;
